export default __webpack_public_path__ + "static/media/Landingpage Voting.4d0ca4f3.mp4";